import { Component, OnInit } from '@angular/core';
import { UserSaveSendDialogService } from 'src/app/services/user-save-send-dialog/user-save-send-dialog.service';
import { trigger, transition } from '@angular/animations';
import { BackdropService } from 'src/app/services/backdrop/backdrop.service';
import { Router } from '@angular/router';
import constants from 'src/app/shared/constants';
import { BuilderService } from 'src/app/services/builder/builder.service';
import { I18nHelperService } from '@xref/ngx';
import { QuestionnaireService } from 'src/app/services/questionnaire/questionnaire.service';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'xqnr-user-save-send-dialog',
    templateUrl: './user-save-send-dialog.component.pug',
    styleUrls: ['./user-save-send-dialog.component.scss'],
    animations: [
        trigger('showHide', [
            transition(':enter', []),
            transition(':leave', [])
        ])
    ],
    standalone: false
})
export class UserSaveSendDialogComponent implements OnInit {
  questionnaireSaving = false;
  questionnaireSending = false;

  fa: any = {
    circleNotch: faCircleNotch
  };

  constructor(
    public userSaveSendDialog: UserSaveSendDialogService,
    private backdrop: BackdropService,
    private router: Router,
    private builder: BuilderService,
    private i18nHelper: I18nHelperService,
    private qs: QuestionnaireService
  ) {}

  ngOnInit() {
    this.backdrop.active$.subscribe((activeState: boolean) => {
      if (!activeState) this.userSaveSendDialog.hide();
    });
  }

  hideDialog() {
    this.resetSavingState();
    this.userSaveSendDialog.hide();
    this.backdrop.hide();
  }

  handleAddXref() {
    this.saveQuestionnaireToXref();
  }

  handleSendEmail() {
    this.sendQuestionnaireToEmail();
  }

  resetSavingState() {
    this.questionnaireSaving = false;
    this.questionnaireSending = false;
  }

  saveQuestionnaireSuccess = () => {
    this.questionnaireSaving = false;
    this.hideDialog();
    this.router.navigate([constants.APP_ROUTE_PATHS.savedToXref]);
  };

  sendQuestionnaireSuccess = () => {
    this.questionnaireSending = false;
    this.hideDialog();
    this.router.navigate([constants.APP_ROUTE_PATHS.sentToEmail]);
  };

  saveQuestionnaireError = (res: any) => {
    console.error(res);
    this.resetSavingState();
  };

  sendQuestionnaireToEmail() {
    if (!this.questionnaireSending) {
      this.questionnaireSending = true;

      this.qs
        .sendQuestionnaireToEmail(this.builder.questionnaire.id)
        .subscribe(this.sendQuestionnaireSuccess, this.saveQuestionnaireError);
    }
  }

  saveQuestionnaireToXref() {
    if (!this.questionnaireSaving) {
      this.questionnaireSaving = true;

      this.qs
        .saveQuestionnaire(this.builder.questionnaire.id, this.i18nHelper.locale)
        .subscribe(this.saveQuestionnaireSuccess, this.saveQuestionnaireError);
    }
  }
}
